/**
 * @file bottomNavTabs.js
 * @description Resolves which mobile bottom navigation tab is active for the current
 * pathname, so the highlight always follows the URL, including nested routes such as
 * /my-messages/{notificationId}.
 */
import { matchPath } from 'react-router-dom';
import { ROUTES } from '../constants/routes';

export const BOTTOM_NAV_TABS = {
    HOME: 'home',
    ASSETS: 'my-assets',
    BENEFITS: 'my-benefits',
    MESSAGES: 'my-messages',
};

const BOTTOM_NAV_TAB_ROUTES = [
    { tab: BOTTOM_NAV_TABS.HOME, pattern: ROUTES.ROOT },
    { tab: BOTTOM_NAV_TABS.HOME, pattern: ROUTES.MY_HOME },
    { tab: BOTTOM_NAV_TABS.HOME, pattern: ROUTES.PORTAL_PAGES_VIEW },
    { tab: BOTTOM_NAV_TABS.HOME, pattern: ROUTES.ASSET_VIEWER },
    { tab: BOTTOM_NAV_TABS.ASSETS, pattern: `${ROUTES.MY_ASSETS}/*` },
    { tab: BOTTOM_NAV_TABS.BENEFITS, pattern: `${ROUTES.MY_BENEFITS}/*` },
    { tab: BOTTOM_NAV_TABS.MESSAGES, pattern: `${ROUTES.MY_MESSAGES}/*` },
];

export function getActiveBottomNavTab(pathname) {
    const matchedRoute = BOTTOM_NAV_TAB_ROUTES.find(
        ({ pattern }) => matchPath(pattern, pathname) !== null,
    );

    return matchedRoute ? matchedRoute.tab : null;
}
